import { MessageType, useHandleNotistack } from "Entity/NotistackHandler";
import { AnyError, displayError, logError } from "Utils/errors";
import * as Sentry from "@sentry/react";

export type HandleErrorCallback = (
    error: AnyError,
    displayToUser?: string,
    logErrorToConsole?: boolean,
    sendToSentry?: boolean,
) => void;

export function useHandleError() {
    const handleNotistack = useHandleNotistack();

    const errorHandler: HandleErrorCallback = (
        error,
        displayToUser,
        logErrorToConsole,
        sendToSentry,
    ) => {
        if (logErrorToConsole !== false) {
            logError(error);
        }
        handleNotistack(MessageType.Err, displayError(displayToUser ?? error));
        if (sendToSentry) {
            Sentry.captureException(error);
        }
        return;
    };

    return errorHandler;
}
